<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Загрузить файлы</h1>
      <div class="file_upload">
        <div class="file_upload_window">
          <b-upload v-model="files" drag-drop multiple @input="$emit('upload')">
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  Вы можете перенести файлы в эту область для загрузки или нажать кнопку Загрузить. Возможна загрузка
                  файлов .pdf и .docx, не превышающих 10 МБ
                </p>
                <p class="upload_file"><i class="mdi mdi-folder-open-outline"></i> Загрузить</p>
              </div>
            </section>
          </b-upload>
        </div>
      </div>
      <!-- <button class="add_course_button modal_button left_button" type="submit">Отправить</button>
            <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    files: {
      default: () => [],
      type: Array
    }
  }
}
</script>
